<div class="credit-info-container flex flex-column gap-3 mb-5" [formGroup]="orderCheckListForm">
  <div>
    <span class="title">
      <app-translate key="ORDER_CHECKLIST"></app-translate>
    </span>
  </div>
  <div>
    <span class="sub-title">
      <app-translate key="READ_ITEMS_BELOW"></app-translate>
    </span>
  </div>
  <p-divider></p-divider>
  <div>
    <span class="sub-title">
      <app-translate key="CONGRATULATIONS_MESSAGE"></app-translate>
    </span>
  </div>
  <div class="border-round">
    @for (term of allOrderList; track term; let i = $index) {
      <div class="mb-4">
        <div>
          <div class="flex mb-2">
            <span class="font-semibold text-xl">{{term.Header}}</span>
          </div>
          <div class="sub-title mb-3">
            <a href="#" target="_self" (click)="onConsumerAgreementClick(term);" class="color-sara-blue">
              <app-translate key="CLICK_READ_TERMS"></app-translate>
            </a>
          </div>
          <div class="sub-title">
            <div class="checkbox-span">
              <p-checkbox inputId="{{term.Id}}" [formControlName]="'item_' + term.Id"
                (onChange)="onConsumerAgreementChecked(term.Id,$event)"
                (onFocus)="sendCustomerInputMessage('order checked state')" [binary]="true" />
              <label for="xcs" class="ml-2" class="sub-title">
                <app-translate key="READ_AND_AGREE_TERMS"></app-translate>
              </label>
            </div>
            <sp-control-error [control]="orderCheckListForm.controls['item_' + term.Id]"
            [messagesParameters]="[{key : 'required', message : languageService.getTranslation('FIELD_MUST_BE_CONFIRMED')}]"></sp-control-error>
          </div>
        </div>
      </div>
      <p-divider></p-divider>
    }
  </div>
  <div>
    @if (signatureRequired && orderCheckListForm.controls['signType']) {
      <div>
        <div class="title text-base">
          <app-translate key="ELECTRONIC_SIGNATURE"></app-translate>
        </div>
        <div class="sub-title mb-3">
          <app-translate key="ESIGN_DISCLOSURE"></app-translate>
        </div>
        <div class="col-12">
          <div class="flex flex-column">
            <label htmlFor="name" class="form-label required">
              <app-translate key="ENTER_FIRST_LAST_NAME"></app-translate>:
            </label>
            <div>
              <input type="text" placeholder="" pInputText
                (onFocus)="sendCustomerInputMessage('order checklist name state')"
                formControlName="signType" class="w-full input-margin" />
            </div>
            <sp-control-error [control]="orderCheckListForm.controls['signType']"
            [messagesParameters]="[{key : 'required', message : languageService.getTranslation('FIELD_MUST_BE_CONFIRMED')}]"></sp-control-error>
          </div>
        </div>
        <div class="sub-title mb-6 mt-3">
          <app-translate key="DIGITAL_SIGNATURE_ACKNOWLEDGEMENT"></app-translate>
        </div>
      </div>
    }
    <div>
      @if (formRequiredValidationShow()) {
        <div class="error-message mb-2">
          <app-translate key="MISSING_SELECTIONS"></app-translate>
        </div>
      }
      <div class="mb-3">
        <p-button [label]="languageService.getTranslation('SUBMIT')" (onClick)="onFormSubmit()"
          styleClass="p-button-lg w-full p-button-primary p-button-radius" />
      </div>
      <div class="mb-3">
        <p-button [label]="languageService.getTranslation('CANCEL')" [link]="true" styleClass="w-full"
          (onClick)="onFormCancel()" />
      </div>
    </div>
    <div>
      <app-translate key="PRIVATE_INFO_SECURITY"></app-translate>
    </div>
  </div>
</div>


<app-confirm-popup [header]="languageService.getTranslation('ARE_YOU_SURE')"
  [title]="languageService.getTranslation('EXTERNAL_LINK_WARNING')" [(isVisible)]="externalLinkPopup"
  (Result)="onExternalPopupAction($event)" [buttonLabel]="languageService.getTranslation('YES')"
  [buttonLabel2]="languageService.getTranslation('CANCEL')"
(onFocus)="sendCustomerInputMessage('external link popup state')"></app-confirm-popup>

<app-confirm-popup [title]="languageService.getTranslation('CANCEL_CONFIRMATION_TEXT')"
  [header]="languageService.getTranslation('CONFIRM_CANCELLATION')" [(isVisible)]="showCancelDialog"
(Result)="onCancelConfimation($event)"></app-confirm-popup>


<app-confirm-popup [header]="languageService.getTranslation('TERMS_AND_CONDITIONS')" [titleWithUrl]="termsText"
  [(isVisible)]="isConsumerAgreementVisible" (Result)="onCancel($event)"
  (isTitleUrlClicked)="onTitleUrlAction($event)" [buttonLabel]="languageService.getTranslation('I_ACKNOWLEDGED')"
  [buttonLabel2]="languageService.getTranslation('CANCEL')"
(onFocus)="sendCustomerInputMessage('agree terms popup state')"></app-confirm-popup>


<app-confirm-popup [header]="languageService.getTranslation('COMPLETE_REQUIRED_FIELDS')"
  [title]="languageService.getTranslation('REQUIRED_FIELDS_MESSAGE')" [(isVisible)]="isRequiredConfirmVisible"
  (Result)="onRequiredPopupAction($event)" [buttonLabel]="languageService.getTranslation('OKAY')"
(onFocus)="sendCustomerInputMessage('required field popupstate')"></app-confirm-popup>